import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

export default class Paginator extends React.Component {
  static propTypes = {
    paginator: PropTypes.object.isRequired,
    handlePageClick: PropTypes.func.isRequired,
    filterViewBook: PropTypes.bool
  };

  render() {
    const { paginator, handlePageClick, filterViewBook } = this.props;

    let libraryFilter = filterViewBook ? 'filtered-bottom' : '';
    if (paginator.total <= 1) {
      return <div />;
    }

    return (
      <ReactPaginate
        previousLabel="<"
        previousClassName="paginator-arrow"
        nextLabel=">"
        nextClassName="paginator-arrow"
        breakLabel="..."
        breakClassName="break"
        disableInitialCallback={true}
        pageCount={paginator.total}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={`paginator ${libraryFilter}`}
        activeClassName="current"
        disabledClassName="disabled"
        forcePage={paginator.page}
      />
    );
  }
}
